/** 路由前缀判定：须整段匹配 /ytb、/dmg，避免 /ytb22、/dmgfoo 误判 */

export function isYtbRoutePath(path) {
  const p = String(path || '').trim()
  return p === '/ytb' || p.startsWith('/ytb/')
}

export function isDmgRoutePath(path) {
  const p = String(path || '').trim()
  return p === '/dmg' || p.startsWith('/dmg/')
}
